<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('user_list_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            color="primary"
                            class="white--text"
                            @click="showForm()"
                            v-if="userCan('users_create')"
                    >
                        {{$t('create')}}
                        <v-icon right dark>mdi-plus</v-icon>
                    </v-btn>
                    <downloadExcel
                            v-if="userCan('receipts')"
                            class            = "btn"
                            :fetch           = "fetchAll"
                            :fields          = "excelFields"
                            name="users.xls"
                    >
                        <v-btn
                                icon
                                small
                        >
                            <v-icon right dark>mdi-file-excel</v-icon>
                        </v-btn>
                    </downloadExcel>
                    <v-btn
                        icon
                        small
                        @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('user_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>

                <Filters
                    :value="filters"
                    :options="filtersOptions"
                >
                    <v-text-field
                            slot="right"
                            v-model.trim="search"
                            label="همراه"
                            :loading="!!searchHandler"
                            class="ml-3 elevation-0"
                            hide-details
                            append-icon="mdi-magnify"
                            outlined
                            single-line
                            dense
                            clearable
                            background-color="#FFF"
                            :style="{ maxWidth: '350px' }"
                    ></v-text-field>
                </Filters>

                <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template #item.full_name="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs" v-on="on"
                                        :color="item.telegram_verified_at ? 'success' : 'error'"
                                >mdi-telegram</v-icon>
                            </template>
                            <span
                                    v-if="item.telegram_verified_at"
                            >{{$t('verified_at', {
                                    verified_at : getJalaliDate(item.telegram_verified_at * 1000)
                                })}}</span>
                            <span
                                    v-else
                            >{{$t('not_verified')}}</span>
                        </v-tooltip>
                        {{item.full_name}}
                        <v-chip
                                v-if="item.role_id"
                                info
                                small
                                class="ma-2"
                                text-color="white"
                        >
                            {{$t('admin')}}
                        </v-chip>

                        <v-chip
                                v-if="item.disabled_at"
                                color="error"
                                small
                                class="ma-2"
                                text-color="white"
                        >
                            {{$t('disabled')}}
                        </v-chip>

                    </template>
                    <template #item.mobile="{item}">
                        {{item.mobile}}
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs" v-on="on"
                                    v-if="item.mobile_verified_at"
                                    color="success"
                                >mdi-check-decagram</v-icon>
                                <v-icon
                                        v-bind="attrs" v-on="on"
                                        v-else color="error">mdi-alert-circle</v-icon>
                            </template>
                            <span
                                v-if="item.mobile_verified_at"
                            >{{$t('verified_at', {
                                    verified_at : getJalaliDate(item.mobile_verified_at * 1000)
                                })}}</span>
                            <span
                                    v-else
                            >{{$t('not_verified')}}</span>
                        </v-tooltip>
                    </template>
                    <template #item.email="{item}">
                        {{item.email}}
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs" v-on="on"
                                        v-if="item.email_verified_at"
                                        color="success"
                                >mdi-check-decagram</v-icon>
                                <v-icon
                                        v-bind="attrs" v-on="on"
                                        v-else color="error">mdi-alert-circle</v-icon>
                            </template>
                            <span
                                    v-if="item.email_verified_at"
                            >{{$t('verified_at', {
                                    verified_at : getJalaliDate(item.email_verified_at * 1000)
                                })}}</span>
                            <span
                                    v-else
                            >{{$t('not_verified')}}</span>
                        </v-tooltip>
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.actions="{item}">
                        
                        <v-tooltip top v-if="userCan('receipts')">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small @click="showForm(item)" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('edit')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="userCan('receipts')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Receipts', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-account-cash</v-icon>
                                </router-link>
                            </template>
                            <span>{{$t('receipts')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('fax_numbers')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'FaxNumbers', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-pound</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('fax_numbers')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('logs_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'SubscriptionList', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-package-variant</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('subscriptions')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('faxes_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'FaxesList', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-inbox-arrow-up</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('sent_faxes_list')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('faxes_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Inbox', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-inbox-arrow-down</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('fax_inbox')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="true || userCan('logs_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Logs', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-math-log</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('logs')}}</span>
                        </v-tooltip>

                    </template>
                </v-data-table>
            </v-card>
            <Form
                    v-if="item"
                    :item="item"
                    @close="item = null"
                    @submit="fetch"
            ></Form>
        </div>
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/UsersService";
    import Form from "../components/UserForm";
    import Filters from "../components/Filters";
    import downloadExcel from "vue-json-excel";

    import config from "@/config";
    export default {
        components : {
            Form,
            Filters,
            downloadExcel
        },
        watch: {
            '$route'() {
                this.syncFiltersWithUrl();
                this.fetch();
            },
            filters: {
                handler(filters) {
                    let filtersQuery = [];

                    Object.values(filters).map(filter => {
                        if (typeof filter.value != 'undefined') {
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query: {
                            filters: filtersQuery,
                            page: this.options.page,
                            count: this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            },
            options: {
                handler(options) {
                    let query = Object.assign(JSON.parse(JSON.stringify(this.$route.query)),{
                        page: options.page,
                        count : options.itemsPerPage
                    });

                    this.$router.push({
                        query : query
                    }).catch(err => err);
                },
                deep: true,
            },
            search(str){
                if( this.searchHandler ){
                    clearTimeout(this.searchHandler);
                }
                let searchFilter = null;
                let searchFilterIndex = null;

                this.filters.forEach((filter, index)=>{
                    if(filter.column_name == 'mobile'){
                        searchFilter = filter;
                        searchFilterIndex = index;
                    }
                });
                searchFilter = searchFilter || {
                    column_name : 'mobile',
                    operand : 'Contains',
                    value : null
                };
                searchFilterIndex = (searchFilterIndex || searchFilterIndex === 0) ? searchFilterIndex : this.filters.length;

                if(!str && (searchFilterIndex || searchFilterIndex === 0 ) ){
                    this.$delete(this.filters, searchFilterIndex);
                    return;
                }

                if( str.length <= 3 ){
                    return '';
                }
                this.searchHandler = setTimeout( () => {
                    searchFilter.value = str;
                    this.$set(this.filters, searchFilterIndex, searchFilter);
                    this.searchHandler = null;
                }, 1000);
            },
        },
        computed: {
            headers(){
                let headers = [];

                Object.values(this.columns).forEach((column) => {

                    let display = typeof column.display == 'undefined' ? true : column.display;

                    if(display){
                        headers.push({
                            text: column.caption,
                            value: column.key,
                        })
                    }
                });

                return headers;

            },
            // filters(){
            //     let filters = this.$route.query.filters || [];
            //     let allowedFilters = [];
            //     if(Object.prototype.toString(filters) === '[object Object]'){
            //         filters = Object.values(filters);
            //     }
            //     filters.forEach((filter) => {
            //         let column = this.columns[filter.column_name] || null;
            //         let filterable = column && (column.filterable || true);
            //         // TODO: check operand
            //        if(filterable){
            //            allowedFilters.push(filter)
            //        }
            //     });
            //     return allowedFilters;
            // },
            excelFields(){
                let excelFields = {};

                Object.values(this.columns).forEach((column) => {
                    let toXls = typeof column.toXls == 'undefined' ? false : column.toXls;

                    if(toXls){
                        excelFields[column.caption] = typeof toXls === 'function' ? toXls : column.key;
                    }
                });

                return excelFields;
            },
            filtersOptions(){
                let filtersOptions = {};

                Object.values(this.columns).forEach((column) => {
                    let filterable = typeof column.filterable == 'undefined' ? true : column.filterable;

                    if(filterable){
                        filtersOptions[column.key] = column;
                    }
                });

                return filtersOptions;
            }
        },
        created() {
            this.syncFiltersWithUrl();
        },
        data() {
            return {
                columns : {
                    id : {
                        key : 'id',
                        caption : this.$t('id'),
                        type : "number",
                        toXls : true,
                    },
                    full_name : {
                        key : 'full_name',
                        caption : this.$t('full_name'),
                        type : "string",
                        toXls : true,
                    },
                    mobile : {
                        key : 'mobile',
                        caption : this.$t('mobile'),
                        quickFilter : true,
                        type : "string",
                        toXls : true
                    },
                    mobile_verified_at : {
                        key : 'mobile_verified_at',
                        caption : this.$t('mobile_verified_at'),
                        type : "timestamp",
                        display : false,
                    },
                    created_at : {
                        key : 'created_at',
                        caption : this.$t('created_at'),
                        type : "timestamp"
                    },
                    email : {
                        key : 'email',
                        caption : this.$t('email'),
                        type : "string",
                        display : false,
                    },
                    email_verified_at : {
                        key : 'email_verified_at',
                        caption : this.$t('email_verified_at'),
                        type : "timestamp",
                        display : false,
                    },
                    telegram_chat_id : {
                        key : 'telegram_chat_id',
                        caption : this.$t('telegram_chat_id'),
                        type : "number",
                        display : false,
                    },
                    telegram_verified_at : {
                        key : 'telegram_verified_at',
                        caption : this.$t('telegram_verified_at'),
                        type : "number",
                        display : false,
                    },
                    total_failed_pay : {
                        key : 'total_failed_pay',
                        caption : this.$t('total_failed_pay'),
                        type : "number",
                        display : false,
                    },
                    last_failed_pay : {
                        key : 'last_failed_pay',
                        caption : this.$t('last_failed_pay'),
                        type : "timestamp",
                        display : false,
                    },
                    total_paid : {
                        key : 'total_paid',
                        caption : this.$t('total_paid'),
                        type : "number",
                        display : false,
                    },
                    last_paid : {
                        key : 'last_paid',
                        caption : this.$t('last_paid'),
                        type : "timestamp",
                        display : false,
                    },
                    disabled_at : {
                        key : 'disabled_at',
                        caption : this.$t('disabled_at'),
                        type : "timestamp",
                        display : false,
                    },
                    updated_at : {
                        key : 'updated_at',
                        caption : this.$t('updated_at'),
                        type : "timestamp",
                        display : false,
                    },
                    actions : {
                        key : 'actions',
                        caption : this.$t('action'),
                        filterable : false
                    },
                },
                filters : [],
                item : null,
                loading : false,
                search : null,
                searchHandler : null,
                options: {
                    page : 1,
                    itemsPerPage : config.itemsPerPage
                },
                items : [],
                total : 0,
                footerProps: {'items-per-page-options': [5, 10,15, 30, 50, 100]}
            }
        },
        methods: {
            syncFiltersWithUrl(){
                let filters = this.$route.query.filters || [];
                let allowedFilters = [];
                if(Object.prototype.toString(filters) === '[object Object]'){
                    filters = Object.values(filters);
                }
                filters.forEach((filter) => {
                    let column = this.columns[filter.column_name] || null;
                    let filterable = column && (column.filterable || true);
                    // TODO: check operand
                    if(filterable){
                        allowedFilters.push(filter)
                    }
                });
                this.filters = allowedFilters;
            },
            async fetch() {
                this.loading = true;
                let requestList = new RequestList();

                this.options.page = parseInt(this.$route.query.page || this.options.page);
                this.options.itemsPerPage = parseInt(this.$route.query.count || this.options.itemsPerPage);

                requestList.setFilters(this.filters);
                requestList.setPage(this.options.page, this.options.itemsPerPage);
                requestList.addOrder('id','desc');
                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.users;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async fetchAll() {
                this.loading = true;

                let requestList = new RequestList();

                requestList.setFilters(this.filters);
                requestList.addOrder('id','desc');

                try {
                    let {data} = await Service.compactList(requestList);
                    return data.value.users;
                } finally {
                    this.loading = false;
                }
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            }

        }
    }
</script>